import template from './bookings.html';
import controller from './bookings.controller';

let bookingsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller,
    controllerAs: 'vm'
};

export default bookingsComponent;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/bookings.component.js